import { render, staticRenderFns } from "./BookPhonesAdminPage.vue?vue&type=template&id=f03b8c02"
import script from "./BookPhonesAdminPage.vue?vue&type=script&lang=js"
export * from "./BookPhonesAdminPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports